import { Col, Row } from 'antd';

import { rbac } from '@utils';
import { AdminOptionCats } from '@types';
import { CxQuestionCategory } from '@network';
import { CxAdminSurvey } from './CxAdminSurvey';
import { InitialCard, InitialPage } from '@components';
import { SettingsOptions } from '@pages/admin-settings/SettingsOptions';
import cls from './AdminSettings.module.css';
import { useSettingsContext } from '@providers';

export const AdminSettings = () => {
  const hasAccess = rbac.isSuperadmin();
  const { isProductPackActive } = useSettingsContext();
  const accessReadonly = false;

  if (!hasAccess) {
    return null;
  }

  return (
    <InitialPage title="Admin Settings">
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={12} xxl={8} className={cls.fullHeight}>
          <InitialCard
            extraPadding
            wrapperClass={cls.partnersSibling}
            left={<div>Sales - Registered Users <small>(max. 8)</small></div>}>
            <SettingsOptions
              category={AdminOptionCats.SALES_USERS_INACTIVITY_REASONS}
              title="Inactivity Reasons"
              maxLength={8}
              canMerge
              readonly={accessReadonly}
            />
          </InitialCard>
          <InitialCard
            extraPadding
            wrapperClass={cls.partnersSibling}
            left={<div>CX - Farms Cycle <small>(max. 8)</small></div>}>
            <SettingsOptions
              category={AdminOptionCats.CX_FARMS_CYCLE}
              title="Cycle"
              maxLength={8}
              canMerge
              readonly={accessReadonly}
            />
          </InitialCard>
        </Col>
        <Col xs={24} xl={12} xxl={16}>
          <InitialCard
            extraPadding
            autoHeight
            minHeight={600}
            left={<div>Partners <small>(max. 8)</small></div>}>
            <Row gutter={[16, 16]}>
              <Col xs={24} xxl={12}>
                <SettingsOptions
                  category={AdminOptionCats.PARTNERS_STATUS}
                  title="Status"
                  maxLength={8}
                  canMerge
                  readonly={accessReadonly}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <SettingsOptions
                  category={AdminOptionCats.PARTNERS_TYPE_BUYER}
                  title="Type - Buyer"
                  maxLength={8}
                  canMerge
                  readonly={accessReadonly}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <SettingsOptions
                  category={AdminOptionCats.PARTNERS_TYPE_RETAILER}
                  title="Type - Retailer"
                  maxLength={8}
                  canMerge
                  readonly={accessReadonly}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <SettingsOptions
                  category={AdminOptionCats.PARTNERS_TYPE_ASSOCIATE}
                  title="Type - Associate"
                  maxLength={8}
                  canMerge
                  readonly={accessReadonly}
                />
              </Col>
            </Row>
          </InitialCard>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={12} xxl={8} className={cls.fullHeight}>
          <InitialCard
            wrapperClass={cls.partnersSibling}
            extraPadding
            autoHeight
            minHeight={360}
            left={<div>Sales - Leads <small>(max. 12)</small></div>}>
            <SettingsOptions
              category={AdminOptionCats.SALES_LEADS_STAGE}
              title="Stage"
              maxLength={12}
              canMerge
              readonly={accessReadonly}
            />
          </InitialCard>
        </Col>
        <Col xs={24} xl={12} xxl={16}>
          <InitialCard
            extraPadding
            autoHeight
            minHeight={360}
            left={<div>Sales - Credits <small>(max. 12)</small></div>}>
            <Row gutter={[16, 16]}>
              <Col xs={24} xxl={12}>
                <SettingsOptions
                  category={AdminOptionCats.SALES_CREDITS_REASON_FOR_REJECTION}
                  title="Reason for Rejections"
                  maxLength={12}
                  canMerge
                  readonly={accessReadonly}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <SettingsOptions
                  category={AdminOptionCats.SALES_CREDITS_RISK_REJECTION_REASON}
                  title="Reviewed in Risk Manager"
                  maxLength={12}
                  canMerge
                  readonly={accessReadonly}
                />
              </Col>
            </Row>
          </InitialCard>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} xl={isProductPackActive ? 12 : 24}>
          <InitialCard
            extraPadding
            autoHeight
            minHeight={360}
            left={<div>Product - Presentation</div>}>
            <SettingsOptions
              category={AdminOptionCats.PRODUCT_PRESENTATION}
              title="Presentation"
              maxLength={999}
              canMerge
              readonly={accessReadonly}
            />
          </InitialCard>
        </Col>
        {isProductPackActive ? (
          <Col xs={24} xl={12}>
            <InitialCard
              extraPadding
              autoHeight
              minHeight={360}
              left={<div>Product - Pack Size</div>}>
              <SettingsOptions
                category={AdminOptionCats.PRODUCT_PACK_SIZE}
                title="Pack Size"
                canMerge
                maxLength={999}
                readonly={accessReadonly}
              />
            </InitialCard>
          </Col>
        ) : null}

      </Row>

      <CxAdminSurvey
        readonly={accessReadonly}
        maxLength={12}
        category={CxQuestionCategory.WELCOME_CALLS}
        title={'CX - Satisfaction Survey'}
        hasAlterName
        hasMultiple
      />
      <CxAdminSurvey
        readonly={accessReadonly}
        maxLength={5}
        category={CxQuestionCategory.FOLLOW_UP}
        title={'CX - Follow Up'}
      />
    </InitialPage>
  );
};
